import { render, staticRenderFns } from "./chujilu.vue?vue&type=template&id=00d2a774&scoped=true&"
import script from "./chujilu.vue?vue&type=script&lang=js&"
export * from "./chujilu.vue?vue&type=script&lang=js&"
import style0 from "./chujilu.vue?vue&type=style&index=0&id=00d2a774&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d2a774",
  null
  
)

export default component.exports